import './InvoicesPanel.pcss';
import React from 'react';
import classnames from 'classnames';
import { FormattedInvoice } from '@mm/state/interfaces/subscription';
import {
  formattedInvoicesSelector,
  selectAccountDetails,
} from '@mm/state/selectors/subscriptionSelectors';
import { CloseOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { Badge, Table } from 'antd';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { useResolutionInfo } from '@mm/hooks';
import { TABLET_SMALL } from '../../../../../editor/constants/screenSize';

const invoiceGridData = [
  {
    title: 'Invoice',
    key: 'invoiceNumber',
    fixed: true,
    render: (invoice: FormattedInvoice) =>
      invoice?.overageCharge ? (
        'Overages charge'
      ) : (
        <a
          href={invoice.invoiceLink}
          target="_blank"
          rel="noreferrer"
          className="invoices-panel__invoice-link"
        >
          #{invoice.invoiceNumber}
        </a>
      ),
  },
  {
    title: 'Posted On',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },
  {
    title: 'Due On',
    dataIndex: 'dueOn',
    key: 'dueOn',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: text => (
      <div className="invoices-panel__status">
        <Badge status={text === 'paid' ? 'success' : 'error'} text={text} />
      </div>
    ),
  },
  {
    title: 'Total',
    dataIndex: 'formattedTotalCost',
    key: 'formattedTotalCost',
    render: cost => (
      <div
        className={classnames('invoices-panel__total-cell', {
          'invoices-panel--is-refund': cost < 0,
        })}
      >
        ${cost}
        <span className="invoices-panel__total-currency">USD</span>
      </div>
    ),
  },
];

export const InvoicesPanel = () => {
  const invoices = useSelector(formattedInvoicesSelector);
  const accountDetails = useSelector(selectAccountDetails);
  const account = accountDetails ? accountDetails.account : null;
  const lastCardNumbers = account ? account.lastCardNumbers : 'XXXX';
  const editBillingLink = account ? account.editBillingLink : '';
  const { closeModal } = useModalActions();
  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= TABLET_SMALL;

  return (
    <div className="invoices-panel">
      <CloseOutlined
        className="invoices-panel__close-icon"
        onClick={() => closeModal()}
      />

      <div className="invoices-panel__title">
        Your Subscriptions Billing History
      </div>

      <div className="invoices-panel__invoices-card-wrapper">
        <div className="invoices-panel__card-wrapper">
          <div className="invoices-panel__card-left-side">
            Your card:
            <div className="invoices-panel__card-number">
              <MoreOutlined
                rotate={90}
                className="invoices-panel__card-number-dots"
              />
              <MoreOutlined
                rotate={90}
                className="invoices-panel__card-number-dots"
              />
              <MoreOutlined
                rotate={90}
                className="invoices-panel__card-number-dots"
              />
              {lastCardNumbers}
            </div>
          </div>

          {editBillingLink && (
            <EditOutlined
              onClick={() => window.open(editBillingLink, '_blank')}
              className="invoices-panel__edit-card-button"
            />
          )}
        </div>
      </div>

      <div className="invoices-panel__invoices-table-wrapper">
        <Table
          dataSource={invoices}
          columns={invoiceGridData}
          size="small"
          scroll={{ x: 500, y: isMobile ? 300 : 500 }}
          pagination={{ hideOnSinglePage: true }}
        />
      </div>
    </div>
  );
};
